// extracted by mini-css-extract-plugin
module.exports = {"check-box-input-wrapper":"check-box-input-wrapper__2usOQ","error":"error__1FbJv"};